import React from 'react';
export function TableButtonsBlock(props) {
    const { buttons, onClickHandler } = props;
    return (
        <div className="buttons-block-header">
            <div id="columnSettingsDialog"></div>
            {buttons && buttons.length > 0 &&
                <ul>
                    {buttons.map((button) => (
                        <li key={button.type} >
                            <button type="button" className={"btn " + (button.btnClass ? button.btnClass : "btn-primary")} onClick={() => { if (onClickHandler) onClickHandler(button.type) }}>{button.title}</button>
                        </li>
                    ))}
                </ul>
            }
        </div>
    );
}